import { render, staticRenderFns } from "./PageDataSection.vue?vue&type=template&id=30487ccd&"
import script from "./PageDataSection.vue?vue&type=script&lang=js&"
export * from "./PageDataSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports